import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import {Spinner} from "../../Spinner";
import {HELP_FACEBOOK_FIXED_ACTIONS, LinkToArticle} from "../../help_center/LinkToArticle";
import {CategorizedActionsSelect} from "../../selects/CategorizedActionsSelect";
import {UpdateItemsInListIcon} from "../../elements/UpdateItemsInList";
import {ChannelLogo} from "../../channels/ChannelLogo";

export class AccountActionsConfigurationClass extends Component {
    constructor(props) {
        super(props);
        this.handleCompareConversionsWithLastPeriodChange = this.handleCompareConversionsWithLastPeriodChange.bind(this);
        this.handleConversionTypesChange = this.handleConversionTypesChange.bind(this);
        this.handleRefreshListItems = this.handleRefreshListItems.bind(this);
    }

    // handle events

    handleCompareConversionsWithLastPeriodChange(event) {
        this.putCheckBoxChangeToServer(this.compareConversionsWithLastPeriodUrl(), event)
    }

    handleConversionTypesChange(selectedActions, useAllPrimaryConversions) {
        this.props.onChange(selectedActions, useAllPrimaryConversions);
    }

    actionDataMap() {
        return (actionData) => {
            return {name: actionData.description, id: actionData.action_id != null ? actionData.action_id.toString() : null};
        }
    }

    handleRefreshListItems() {
        if(this.props.onRefreshListItems !== undefined)
            this.props.onRefreshListItems();
    }

    // render

    _renderRefreshListItemsIcon(){
        if(this.props.onRefreshListItems === undefined)
            return null;

        return <div className="refresh_list_items_icon">
            <UpdateItemsInListIcon
                message={this.props.messageForRefreshListItemsIconToolbox}
                isBeingSyncedOnDemand={this.props.isUpdatingListItems}
                onClick={this.handleRefreshListItems}
            />
        </div>
    }

    _renderTextWithUserIndication() {
        const {t} = this.props;
        // Era el único string hardcodeado que quedaba en el archivo, y estaba justo ARRIBA del
        // aviso que sí se tradujo: en inglés el bloque quedaba con la instrucción en español y el
        // aviso en inglés, peor que cuando todo estaba en español.
        if (this.props.showTextWithUserIndication === undefined || this.props.showTextWithUserIndication === true)
            return <label key={0}>{t('account_actions.select_events')}<LinkToArticle
                article={HELP_FACEBOOK_FIXED_ACTIONS}/></label>
        return null;
    }

    _renderAdAccountHeader() {
        if (this.props.showAdAccountHeader === undefined || this.props.showAdAccountHeader === false)
            return null;

        return <div className={"ad_account-header"}><ChannelLogo hspace={0} vspace={0} channel={this.props.channel}/>{`${this.props.name} (Id: ${this.props.accountId})`}</div>
    }

    /**
     * Cuántos eventos DISTINTOS registró la cuenta en los últimos 30 días.
     *
     * `null` cuando el canal no informa conteos: ahí no se puede decir ni "registró N" ni
     * "registró ninguno" — son cosas distintas y confundirlas es justo lo que dejó a un usuario
     * sin poder interpretar un cero.
     */
    _actionsWithData() {
        const actions = this.props.allActions || [];
        if (!actions.some(action => !!action.counts)) return null;
        return actions.filter(action => action.counts && (
            action.counts.yesterday || action.counts.last_7_days || action.counts.last_30_days
        ));
    }

    _eventsWithDataCount() {
        const withData = this._actionsWithData();
        return withData === null ? null : withData.length;
    }

    /**
     * El aviso de que no hay eventos elegidos, CON el dato adentro.
     *
     * El cartel ya existía y decía sólo qué estaba mal ("no tienes ningún evento seleccionado").
     * Eso no le alcanzó a nadie: no dice qué hay disponible ni por dónde empezar. Es el mismo
     * cartel, en el mismo lugar, con los dos números que Dashbo ya tenía.
     */
    _renderNoEventsWarning() {
        const {t} = this.props;
        const withData = this._eventsWithDataCount();
        const message = withData === null || withData === 0
            ? t('account_actions.no_events_selected')
            : t('account_actions.no_events_selected_with_data', {count: withData});

        return (
            <div className="form-row" key="no-events-warning">
                <div className="alert alert-warning col-12 pl-2 mb-0" role="alert">{message}</div>
            </div>
        );
    }

    /**
     * Cuando SÍ hay eventos elegidos: cuántos de los que la cuenta registra están entrando.
     *
     * `selected` se INTERSECTA con los que tienen datos. Contar los elegidos a secas publicaba un
     * número falso justo en el caso que originó el frente: una cuenta con 2 eventos elegidos que
     * no registran nada y 3 eventos distintos con datos decía «estás contando 2 de los 3» cuando
     * la cobertura real era 0 de 3 — una frase tranquilizadora sobre una línea que mide cero.
     */
    _renderCoverageLine() {
        const {t} = this.props;
        // Llegar acá con la selección VACÍA significa «todas las conversiones primarias»: el único
        // camino que no cae en `_renderNoEventsWarning()`. La cobertura habla de los eventos que el
        // usuario eligió a mano, así que bajo ese modo su premisa no aplica y el número sale 0
        // — «estás contando 0 de los N» arriba de un checkbox tildado que dice lo contrario.
        if ((this.props.selectedActions || []).length === 0) return null;

        const withData = this._actionsWithData();
        if (!withData || withData.length === 0) return null;

        const withDataIds = new Set(withData.map(action => action.action_id));
        const selectedCount = (this.props.selectedActions || [])
            .filter(id => withDataIds.has(id)).length;
        if (selectedCount >= withData.length) return null;

        return (
            <p className="account-actions-coverage" key="coverage">
                {t('account_actions.coverage', {selected: selectedCount, total: withData.length})}
            </p>
        );
    }

    _renderConversionsMultiSelect() {
        if (this.props.allActions !== null && this.props.selectedActions !== null) {
            const ret = [this._renderAdAccountHeader(), this._renderTextWithUserIndication(),this._renderRefreshListItemsIcon()];
            const noEventsSelected = this.props.selectedActions.length === 0 && (
                !this.props.hasIncludeAllConversionsSetting ||
                this.props.useAllPrimaryConversions === false
            );
            if(noEventsSelected)
                ret.push(this._renderNoEventsWarning());
            else
                ret.push(this._renderCoverageLine());

            ret.push(
                    <CategorizedActionsSelect key={1}
                                        items={this.props.allActions}
                                        itemDataMap={this.actionDataMap()}
                                        selectedItemIds={this.props.selectedActions}
                                        onChange={this.handleConversionTypesChange}
                                        hasAllPrimaryConversionsOption={this.props.hasIncludeAllConversionsSetting}
                                        useAllPrimaryConversions={this.props.useAllPrimaryConversions}
                                        channel={this.props.channel}
                    />);
            return ret;
        } else {
            return <Spinner color="positive"/>
        }
    }

    render() {
        return (
            this._renderConversionsMultiSelect()
        )
    }
}

export const AccountActionsConfiguration = withTranslation()(AccountActionsConfigurationClass);
export default AccountActionsConfiguration;
